import dayjs from 'dayjs';

export const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export function getLastLoginLabel(lastLogin: number) {
  const target = dayjs(lastLogin);
  const now = dayjs();

  const diffSeconds = Math.abs(target.diff(now, 'second'));
  const diffMinutes = Math.abs(target.diff(now, 'minute'));
  const diffHours = Math.abs(target.diff(now, 'hour'));
  const diffDays = Math.abs(target.diff(now, 'day'));
  const diffMonths = Math.abs(target.diff(now, 'month'));
  const diffYears = Math.abs(target.diff(now, 'year'));

  if (diffSeconds < 45) return 'Just now';
  if (diffMinutes < 1.5) return 'A minute ago';
  if (diffMinutes < 60) return `${diffMinutes} minutes ago`;
  if (diffHours < 1.5) return 'An hour ago';
  if (diffHours < 24) return `${diffHours} hours ago`;
  if (diffDays < 1.5) return 'A day ago';
  if (diffDays < 30) return `${diffDays} days ago`;
  if (diffMonths < 1.5) return 'A month ago';
  if (diffMonths < 12) return `${diffMonths} months ago`;
  if (diffYears < 1.5) return 'A year ago';
  return `${diffYears} years ago`;
}

export function formatTimeTaken(startedAt: number, endedAt: number): string {
  const totalMs = Math.abs(endedAt - startedAt);
  const totalSeconds = totalMs / 1000;

  if (totalMs === 0) {
    return '0s';
  }

  if (totalSeconds < 10) {
    return `${totalSeconds.toFixed(1)}s`;
  }

  const seconds = Math.floor(totalSeconds % 60);
  const minutes = Math.floor((totalSeconds / 60) % 60);
  const hours = Math.floor((totalSeconds / 3600) % 24);
  const days = Math.floor(totalSeconds / 86400);

  const parts: string[] = [];
  if (days) parts.push(`${days}d`);
  if (hours) parts.push(`${hours}h`);
  if (minutes) parts.push(`${minutes}m`);
  if (seconds) parts.push(`${seconds}s`);

  return parts.slice(0, 3).join(' ');
}
